import { jsx as _jsx } from "react/jsx-runtime";
import { getAppRoutePermissions } from '@repo/guards/route-checks';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { getGetApplicationQueryOptions, getGetApplicationSummaryQueryOptions } from 'ze-sdk';
export const Route = createFileRoute('/org/$organization/$project/$application')({
    component: Component,
    loader: async (param)=>{
        let { params, context } = param;
        const { application, project, organization } = params;
        // Prefetch application data into query cache (existing behavior)
        await Promise.all([
            context.queryClient.ensureQueryData(getGetApplicationQueryOptions({
                application,
                project,
                organization
            })),
            context.queryClient.ensureQueryData(getGetApplicationSummaryQueryOptions({
                application,
                project,
                organization
            }))
        ]);
        // Fetch permissions for Layout navigation
        const permissions = await getAppRoutePermissions(context.queryClient, organization, project, application);
        return {
            permissions
        };
    }
});
function Component() {
    return /*#__PURE__*/ _jsx(Outlet, {});
}
